export enum PaymentSources
{
    PSP = 1,
    CASH = 2,
    PINPAD = 3
}